/**
 * Lets long-running work mark the user as active for the session inactivity
 * timeout (TimeoutModal) when that work produces no DOM events the modal can
 * hear — recording a voice answer, listening back to audio. Without this, a
 * user speaking into the mic for ten minutes looks idle and gets the timeout
 * warning mid-recording (TK-2983 AC 10.1).
 */
export const SESSION_ACTIVITY_EVENT = 'everplans:session-activity'

export const touchSessionActivity = () => {
  document.dispatchEvent(new CustomEvent(SESSION_ACTIVITY_EVENT))
}
